import { FC } from 'react';
import classNames from 'classnames';
import { TypeTabContent } from '@/core/generated-types/TypeTabContent';

interface TabContentProps {
  tab: TypeTabContent;
  isPill: boolean;
  isActive: boolean;
  isFirst: boolean;
  isLast: boolean;
}

export const TabContent: FC<TabContentProps> = ({
  tab,
  isPill,
  isActive,
  isFirst,
  isLast,
}) => {
  const { leadingIcon, trailingIcon, textAlign, label, subLabel } = tab.fields;

  const containerClass = {
    'flex justify-center items-center font-bold whitespace-nowrap text-grey-dark':
      true,
    'h-[60px] lg:h-[74px] px-2 md:px-4': isPill,
    'bg-white border border-grey-midtone': !isActive && isPill,
    'bg-blue-deep text-white': isActive && isPill,
    'h-[70px] lg:h-20 mx-2 lg:mx-3': !isPill,
    'border-b-[3px] border-blue-deep': isActive && !isPill,
    'rounded-l-[4px]': isPill && isFirst,
    'rounded-r-[4px]': isPill && isLast,
  };

  const iconLeadingClass = {
    'lg:scale-125': true,
    block: leadingIcon,
    hidden: !leadingIcon,
  };

  const textSizeClass = {
    'text-base lg:text-xl': isPill,
    'text-base lg:text-lg': !isPill,
  };

  const iconTrailingClass = {
    'lg:scale-125': true,
    block: trailingIcon,
    hidden: !trailingIcon,
  };

  const textAlignClass = {
    'flex-col': true,
    'text-center': textAlign === 'center',
    'text-left': textAlign !== 'left',
    'md:mx-2': isPill,
  };

  return (
    <div className={classNames(containerClass)}>
      <div className={classNames(iconLeadingClass)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-6 h-6 text-base"
        >
          <path
            fillRule="evenodd"
            d="M4.293 12.293a1 1 0 011.414 0L10 16.586l8.293-8.293a1 1 0 111.414 1.414l-9 9a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <div className={classNames(textAlignClass)}>
        <div className={classNames(textSizeClass)}>{label}</div>
        {subLabel && <div className="text-xs lg:text-sm">{subLabel}</div>}
      </div>
      <div className={classNames(iconTrailingClass)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-6 h-6"
        >
          <path
            fillRule="evenodd"
            d="M12 4a1 1 0 011 1v6h6a1 1 0 110 2h-6v6a1 1 0 11-2 0v-6H5a1 1 0 110-2h6V5a1 1 0 011-1z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>
  );
};
